export const TAG_NAME = 'mark';
export const CACHE_KEY_HIGHLIGHT_ENABLE = 'CACHE_KEY_HIGHLIGHT_ENABLE';
export const CACHE_KEY_HIGHLIGHT_CONFIG = 'CACHE_KEY_HIGHLIGHT_CONFIG';
export const HIGHLIGHT_TARGET_CLASS = 'patsnap-highlight-target';
export const CLASS_HIGHLIGHT_SEARCH = 'patsnap-search-hit';
export const STYLE_COLOR_HIGHLIGHT_SEARCH = '#F5EFEE';
export const SELECTOR_DENSITY_TARGETS = `mark[data-keyword]:visible,.${CLASS_HIGHLIGHT_SEARCH}:visible,.${CLASS_HIGHLIGHT_SEARCH}-0:visible,.${CLASS_HIGHLIGHT_SEARCH}-1:visible,.${CLASS_HIGHLIGHT_SEARCH}-2:visible,.${CLASS_HIGHLIGHT_SEARCH}-3:visible,.${CLASS_HIGHLIGHT_SEARCH}-4:visible`;
export const RE_HIGHLIGHT_TAG = new RegExp(`<span class='${CLASS_HIGHLIGHT_SEARCH}(-\\d)?'>(.*?)</span>`, 'g');
/**
 * 去除服务端高亮标签
 * @param text 可能带服务端高亮标签的文本
 */
export const replaceHighlightTag = (text) => {
    if (!text || !text.includes(CLASS_HIGHLIGHT_SEARCH))
        return text;
    return replaceHighlightTag(text.replace(RE_HIGHLIGHT_TAG, (...rest) => rest[2]));
};
// 包裹高亮文本的滚动元素，如果滚动 dom 结构有修改，需要更新这个值
export const CLASS_NAME_CHEMICAL_HIGHLIGHT_SCROLL_DOM = 'highlight-box-scroll';
export const SELECTOR_CHEMICAL_HIGHLIGHT_SCROLL_DOM = `.${CLASS_NAME_CHEMICAL_HIGHLIGHT_SCROLL_DOM}`;
export const HIGHLIGHT_COLORS = Object.freeze(['#E89B2F', '#F07DE8', '#859BFF', '#78EBD6', '#CBE655']);
export const HIGHLIGHT_DEFAULT_KEYWORDS = ['', '', '', ''];
export const HIGHLIGHT_CHANNEL_IDENTITY = `HIGHLIGHT_CHANNEL_IDENTITY-${Date.now()}`;
export function getKeywordsSplitRegExp() {
    return new RegExp(';|；|\\sOR\\s', 'img');
}
export const quotationMarkAliens = new Set(['‘', '’', '"', '‘', '’', '“', '”', '\'']);
export const FOCUSED_CLASSNAME = 'patsnap-mark-current-focus';
export const quotationMarkRegExp = /(\'[^']*\'?)|(\"[^"]*\"?)|(‘[^’]*’?)|(“[^”]*”?)/g; ///[‘’"'‘’“”]/g;
//# sourceMappingURL=contants.js.map